import { useState } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import SubdirectoryArrowRightRoundedIcon from '@mui/icons-material/SubdirectoryArrowRightRounded'
import GuruInsightModal from 'features/bpDetails/Components/files/GuruInsightModal'
import useTaskRelated from 'features/taskLinks/useTaskRelated'
import { originOf } from 'features/taskLinks/origin'
import { LINK, MUTED } from 'features/actions/workspace/ui'

const TaskOrigin = ({ taskId, bpId, bpName }) => {
  const [openFile, setOpenFile] = useState(null)
  const { result } = useTaskRelated(taskId)
  const origin = result && !result.failed ? originOf(result.data) : null

  if (!origin) return null

  const { remedial, document } = origin
  const docButton = document && (
    <DocLink
      type='button'
      onClick={() => setOpenFile({ id: document.fileId, displayName: document.name, buildingPassportId: bpId, buildingPassportName: bpName })}
      aria-label={`Open the document ${document.name}`}
    >
      {document.name}
    </DocLink>
  )

  return (
    <Wrap data-testid='task-origin'>
      <SubdirectoryArrowRightRoundedIcon aria-hidden='true' />
      <Text>
        {remedial ? (
          <>
            <span>
              Raised from the remedial <RemLink to={`/actions/${remedial.id}`}>{remedial.title}</RemLink>. Completing this task closes the remedial.
            </span>
            {docButton && <span>Document: {docButton}</span>}
          </>
        ) : (
          <span>Created from the document: {docButton}</span>
        )}
      </Text>
      {openFile && (
        <GuruInsightModal
          open
          onClose={() => setOpenFile(null)}
          file={openFile}
          bpId={openFile.buildingPassportId}
          buildingPassportName={openFile.buildingPassportName}
        />
      )}
    </Wrap>
  )
}

export default TaskOrigin

const Wrap = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 14px;
  padding: 10px 14px;
  border: 1px solid #cfe7ea;
  background: #f2fbfb;
  border-radius: 10px;
  font-size: 15px;
  line-height: 1.5;
  color: ${MUTED};
  overflow-wrap: anywhere;

  svg {
    flex-shrink: 0;
    margin-top: 2px;
    font-size: 20px;
    color: ${LINK};
  }
`

const Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`

const RemLink = styled(Link)`
  font-weight: 700;
  color: ${LINK};
  text-decoration: underline;
  text-underline-offset: 3px;
`

const DocLink = styled.button`
  padding: 0;
  border: none;
  background: none;
  font: inherit;
  font-weight: 700;
  color: ${LINK};
  text-align: left;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
`
